import React, { Fragment, useContext, useEffect, useState } from "react";
import { Alert, Box, Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from "@mui/material";
import { format } from "date-fns";
import ReactMustache from 'react-mustache';
import { Cancel, EscalatorWarning } from "@mui/icons-material";
import { AccessTime } from "@material-ui/icons";
import { formatInTimeZone } from "date-fns-tz";
import { SelectorContext } from "../../../contexts/SelectorContext";
import { BrandContext } from "../../../contexts/BrandContext";
import { cWarn } from "../CustomLogger";
import axios from "../../../utils/axios";
import { LoadingBox } from "../UniversalComponents";
import { StaffApprovalIcon, formatTime, getComponentsFromUtcDate, hoursMinToTimeString, iconMap, outputCurrency } from "../../../contexts/BookingUtilities";
import ProgressIcon from "./ProgressIcon";
import ParentApprovalIcon from "../BookingsCommon/ParentApprovalIcon";
import CustomMenuList from "../CustomMenuList";
import CancelBookingDialogue from "../BookingsCommon/CancelBookingDialogue";
import BasicBookingsDialogue from "../BookingsCommon/BasicBookingsDialogue";
import TimeEdit from "./TimeEdit";
import UmStatusIcon from "./UmStatusIcon";
import UMToggleDialogue from "./UmTogleDialogue";
import { ProfileContext } from "../../../contexts/ProfileContext";
import AdminData from "./AdminData";
import AdminFareBreakdown from "./AdminFareBreakdown";



export default function DetailDialogue(props){

    const {
        showDialogue=false,
        setShowDialogue,
        taxiId=0,
        profile:profileKey='fp'
    } = props;
    

    const [isLoaded,setIsLoaded] = useState(false);
    const [data,setData] = useState(null);
    const brandContext = useContext(BrandContext);
    const {
            brand:{
                mode:scope,
            }
    } = brandContext;

    const defaultOptions = {
        changeTime:false,
        viewStudentTools:false,
        approval:false
    };

    const selectorContext = useContext(SelectorContext);
    

    

   
    const profileContext = useContext(ProfileContext);
    const [showLog,setShowLog] = useState(false);
    const {
        profile:{
            hasSuperRights:isAdminProfile=false
        }
    } = profileContext;


     /* eslint-disable */
     useEffect(() => {
        // Update the document title using the browser API
        if(!isLoaded){

            let apiPath = `${process.env.REACT_APP_API_URL}/taxidetails/${scope}/${taxiId}`;

            if(scope === 'fpCo'){
                const {
                    unit:{
                        id:fpCoId
                    }
                } = selectorContext;

                apiPath = `${process.env.REACT_APP_API_URL}/fptaxidetails/${fpCoId}/${taxiId}`;
            }


            

            axios.get(apiPath,{
                timeout: 300000,
                withCredentials:true
            }).then(res => {

                const {
                    data:taxiData
                } = res;
                setData(taxiData);
                setIsLoaded(true);
            }).catch(err => {
                cWarn(err); 
            });

        }
    },[isLoaded]);
    /* eslint-enable */

    const profileMap = {
        school:{
            changeTime:true,
            viewStudentTools:true,
            approval:true,
            showLog:false
        },
        travelCo:{
            changeTime:true,
            viewStudentTools:true,
            approval:true,
            showLog:true
        },
        fpCo:{
            showLog:false,
        }
    };

    const options = {...defaultOptions,...profileMap[profileKey]};


    const InnerDialogue = ()=>{

        const brandContext = useContext(BrandContext);
        const {
            textContent:{
                taxiBookingInformationTitle='',
                closeButton='',
                bookingTimeLabel='',
                shareCodeLabel='',
                yourTaxiIsBookedWithProvider='',
                bookingIdLabel='',
                passengers='',
                luggageTaxiLabel='',
                houseLabel='',
                bookedBy='',
                changeTimeButton='',
                bookingRefLabel='',
                openStudentButton='',
                viewBookingButton='',
                cancelBookingButton='',
                taxiPointFromLabel='',
                taxiPointViaLabel='',
                taxiPointToLabel='',
                flightInfoLabel='',
                arrivingFlightTitle='',
                departingFlightTitle='',
                flightLabelTerminal='',
                toggleUmButton='',
                taxiCoRefLabel='',
                driverLabel='',
                vehicleLabel='',
                theTaxiWasCancelledOn='',
                theTaxiWasCancelledNoTStamp=''
            },
            textContent
        } = brandContext;

        const {
            fullData:{
                id:taxiBookingId,
                legToTaxis,
                shareCode,
                taxiBookingJobs=[]
            },
            fullData,
            fromPoints=[],
            toPoints=[],
            flights={},
            internalFareBreakdown={},
            customerFareBreakdown={},
            allowFpEditTime=false,
            taxiJob=null
        } = data;

        let {cancelationTStamp=null,cancelled=false,} = data;

        let dateLabel = '';
        let timeLabel = '';
        let fromPointId=0;
        let fromPointTime = '';
        if(fromPoints.length > 0){
            
            const basePoint = fromPoints[0];
            ({
                id:fromPointId,
                pointTime:fromPointTime
            } = basePoint);

            const{
                year,
                month,
                day,
                hours,
                mins

            } = getComponentsFromUtcDate(fromPointTime);

            dateLabel = `${day}/${month}/${year}`;
            const date = new Date(year, month - 1, day);
            dateLabel = format(date, 'do MMM yyyy', { useAdditionalWeekYearTokens: true });
            timeLabel = `${hours}:${mins}`;
        } 

        let schoolName = '';
        if(legToTaxis.length > 0){
            const {
                bookingLeg:{
                    booking:{
                        studentToBookings
                    }
                }
            } = legToTaxis[0];
            if(studentToBookings.length > 0){
                for(let i=0; i<studentToBookings.length; i+=1){
                    const passenger = studentToBookings[i];
                    if(passenger.student){
                        ({student:{school:{schoolName}}} = passenger);
                    }
                }
            }
        }

        const passengerList = [];
        for(let i=0; i<legToTaxis.length; i+=1){
            const {
                bookingLeg:{
                    booking:{
                        studentToBookings = []
                    }
                }
            } = legToTaxis[i];
            for(let j=0; j<studentToBookings.length; j+=1){
                passengerList.push(studentToBookings[j]); 
            }
        }

        let statusId = 1;
        let fp = null;
        let taxiCompanyName = '';
        let fpTel='';
        let fpEmail='';
        let driverContactNo = '';
        let driverName = '';
        let externalId = '';
        let vehicleDescription = '';
        let vehicleReg = '';
        if(taxiBookingJobs.length > 0){
            for(let i=0; i<taxiBookingJobs.length; i+=1){
                if(taxiBookingJobs[i].isActive){
                    const taxiBookingJob = taxiBookingJobs[i];
                    ({
                        status:{
                            id:statusId
                        },
                        driverContactNo='',
                        driverName='',
                        externalId='',
                        vehicleDescription='',
                        vehicleReg='',
                        fp
                    } = taxiBookingJob);
                    break;
                }
            }
        }
        if(externalId){
            externalId = externalId.split('-')[externalId.split('-').length-1];        }
        if(fp){
            ({
                companyName:taxiCompanyName,
                fpTel,
                fpEmail
            } = fp);

        }

        const [showBookingDialogue,setShowBookingDialogue] = useState(false)
        const [bookingDialogueBooking,setBookingDialogueBooking] = useState({});
        

        const [showBookingCancelDialogue,setShowBookingCancelDialogue] = useState(false)
        const [cancelBookingId,setCancelBookingId] = useState(0);
        const updateAfterCancel = () => {
            setIsLoaded(false);
        }

        const [timeEdit,setTimeEdit] = useState({
            showDialogue:false,
            wayPointId:0,
            pointTime:''
        });
        const setShowEditDialogue = (show) =>{
            setTimeEdit({
                ...timeEdit,
                showDialogue:show,
            });
        }

        const [umDialogue,setUmDialogue] = useState({
            showDialogue:false,
            stb:null
        })
        let cancelationTStampLabel = '';
        const totLuggage = legToTaxis.reduce((total, leg) => total + leg.luggage, 0);
        
        if(allowFpEditTime){
            if(profileKey === 'fpCo'){
                options.changeTime = true;
            }
        }
        

        let jobStatus = '';
        let externalStatus = '';
        let jobId = '';
        if(scope === 'fpCo'){
            const {
                taxiJob:{
                    activationStatus:{
                        textKey:jobStatusTextKey=''
                    },
                    status:{
                        name:externalStatusTextKey=''
                    }
                }
            }   = taxiJob;
            if(jobStatusTextKey){
                jobStatus = textContent[jobStatusTextKey];
                externalStatus = textContent[externalStatusTextKey];
            }
            ({
                taxiJob:{
                    id:jobId,
                },
                cancelTime:cancelationTStamp,
                cancelled
            } = taxiJob);
        }

        if(cancelled){
            options.changeTime = false;
            if(cancelationTStamp){
                const timeZone = 'Europe/London';
                cancelationTStampLabel = formatInTimeZone(
                    new Date(cancelationTStamp), 
                    timeZone, 
                    "dd MMM yyyy 'at' HH:mm"
                );
            }
        }

        return(
            <>
                <DialogTitle sx={{backgroundColor:'#CCCCCC'}}>
                    {taxiBookingInformationTitle}
                </DialogTitle>
                <DialogContent>
                    {cancelled && 
                        <Alert severity="error" sx={{marginTop:2}}>
                            {cancelationTStampLabel ?
                                <>{theTaxiWasCancelledOn}{cancelationTStampLabel}</>
                                :
                                <>{theTaxiWasCancelledNoTStamp}</>
                            }
                           
                        </Alert>
                    }
                    <Box sx={{display:'flex', marginTop:2, marginBottom:2}}>
                        <Box sx={{flexGrow:1}}>
                            <Box sx={{display:'flex', alignItems:'center', flexDirection:'row'}}>
                                <Box sx={{marginRight:2}}>
                                    <Typography variant="h5"><ReactMustache Component="span" template={bookingTimeLabel} data={{date:dateLabel,time:timeLabel}}/></Typography>
                                </Box>
                                {options.changeTime &&
                                <Box>
                                    {fromPointId &&
                                        <Button variant="outlined" onClick={()=>{
                                            setTimeEdit({
                                                showDialogue:true,
                                                wayPointId:fromPointId,
                                                pointTime:fromPointTime
                                            })
                                        }}>
                                            {changeTimeButton}
                                        </Button>
                                    }
                                </Box>
                                }
                            </Box>
                            <Typography>{schoolName}</Typography>
                            <Typography>{shareCodeLabel} <Typography component="span" className="bodyBold">{shareCode}</Typography></Typography>
                            <Typography>{yourTaxiIsBookedWithProvider} <Typography component="span" className="bodyBold">{taxiCompanyName} {externalId && `(${taxiCoRefLabel} ${externalId})`}</Typography></Typography>
                            {driverName && <Typography>{driverLabel} {driverName}</Typography>}
                            {(vehicleReg || vehicleDescription) && <Typography>{vehicleLabel} {vehicleDescription} {vehicleReg}</Typography>}
                            <Typography>{bookingIdLabel} {taxiBookingId}{jobId && `-${jobId}`}</Typography>
                            <Typography><Typography component="span" className="bodyBold">{luggageTaxiLabel}</Typography> {totLuggage}</Typography>
                        </Box>
                        <Box>
                            <ProgressIcon taxiBooking={fullData} onClick={()=>{
                                const url = `/tracktaxi/${taxiId}`;
                                window.open(url, '_blank');
                            }} >T</ProgressIcon>
                        </Box>
                   </Box>
                   <Divider />
                   <Box sx={{marginTop:1, marginBottom:2}}>
                        <Typography variant="h5" sx={{textTransform:'capitalize'}}>{passengers}</Typography>
                        {legToTaxis.map((ltt,i)=>{
                            
                            const {
                                bookingLeg:{
                                    booking:{
                                        studentToBookings = [],
                                        parentContact,
                                        id:bookingId,
                                        isCancelled=false,
                                    }, 
                                    booking,
                                    legWaypoints
                                },
                                luggage=0
                            } = ltt;
                            let bookerName = '';
                            if(parentContact){
                                const {
                                    firstName='',
                                    lastName=''
                                } = parentContact;
                                bookerName = `${firstName} ${lastName}`;
                            }
                            let legFromPointId = 0;
                            let legFromPointTime='';
                            if(legWaypoints.length > 0){
                                for(let j=0; j<legWaypoints.length; j+=1){
                                    
                                    const legBasePoint = legWaypoints[j];
                                    ({
                                        id:legFromPointId,
                                        pointTime:legFromPointTime
                                    } = legBasePoint);       
                                    if(legFromPointTime){
                                        break;
                                    }
                                }             
                            } 
                            

                            return (
                            <Fragment key={i}>
                                {studentToBookings.map((stb,j)=>{
                                    const {
                                        student=null,
                                        staff=null,
                                        contact=null
                                    } = stb;
                                    if(student){
                                        let houseName = '';
                                        const {
                                            firstName='',
                                            lastName='',
                                            SchoolHouse,
                                            id:studentId
                                        } = student;
                                        if(SchoolHouse){
                                            ({name:houseName} = SchoolHouse);
                                        }
                                        
                                        return (
                                            <Box className={`${isCancelled && 'bookingCancelled'}`} key={j}>
                                                <Box  sx={{display:'flex', marginBottom:1}}>
                                                    <Box sx={{flexGrow:'1'}}>
                                                        <Typography className="bodyBold">{firstName} {lastName}</Typography>
                                                        {houseName && <Typography><Typography component="span" className="bodyBold">{houseLabel}</Typography> {houseName}</Typography>}
                                                        <Typography className="smallText">{bookedBy} {bookerName}</Typography>
                                                    </Box>
                                                    <Box>
                                                        <Box sx={{display:'flex', justifyContent:'flex-end'}}>
                                                            <UmStatusIcon stb={stb}/>
                                                            {options.viewStudentTools &&
                                                            <>
                                                                <StaffApprovalIcon booking={booking} studentId={studentId}/>
                                                                <ParentApprovalIcon booking={booking}/>
                                                                <CustomMenuList 
                                                                    id={j}
                                                                    options={[
                                                                        {
                                                                            text: viewBookingButton,
                                                                            iconComponent: iconMap.Travel,
                                                                            action: () => {
                                                                                setBookingDialogueBooking(booking);
                                                                                setShowBookingDialogue(true);
                                                                            },
                                                                            branded: true
                                                                        },
                                                                        { text: openStudentButton, iconComponent: iconMap.Open, to:`/student/${studentId}`, branded:true },
                                                                        {
                                                                            text: cancelBookingButton,
                                                                            iconComponent: <Cancel/>,
                                                                            action: () => {
                                                                                setCancelBookingId(bookingId);
                                                                                setShowBookingCancelDialogue(true);
                                                                            },
                                                                            branded: true,
                                                                        },
                                                                        {
                                                                            text: changeTimeButton,
                                                                            iconComponent: <AccessTime/>,
                                                                            action: () => {
                                                                                setTimeEdit({
                                                                                    showDialogue:true,
                                                                                    wayPointId:legFromPointId,
                                                                                    pointTime:legFromPointTime
                                                                                })
                                                                            },
                                                                            branded: true,
                                                                        },
                                                                        {
                                                                            text: toggleUmButton,
                                                                            iconComponent: <EscalatorWarning/>,
                                                                            action: () => {setUmDialogue({showDialogue:true,stb})},
                                                                            branded: true
                                                                        },
                                                                    ]}
                                                                />
                                                            </>
                                                            }
                                                        </Box>
                                                        <Box sx={{display:'flex', justifyContent:'flex-end'}}>
                                                            <Typography sx={{textAlign:'right'}} className="smallText">{bookingRefLabel} <Typography component="span" className="smallText bodyBold">{bookingId}</Typography></Typography>
                                                        </Box>
                                                        
                                                    </Box>
                                                </Box>
                                                <Divider/>
                                            </Box>
                                        );
                                    }
                                    if(contact){
                                        const {
                                            firstName='',
                                            lastName='',
                                            id:contactId
                                        } = contact;
                                        
                                        return (
                                            <Box className={`${isCancelled && 'bookingCancelled'}`} key={j}>
                                                <Box  sx={{display:'flex', marginBottom:1}}>
                                                    <Box sx={{flexGrow:'1'}}>
                                                        <Typography className="bodyBold">{firstName} {lastName}</Typography>
                                                        <Typography><Typography component="span" className="bodyBold">{luggageTaxiLabel}</Typography> {luggage}</Typography>
                                                        <Typography className="smallText">{bookedBy} {bookerName}</Typography>
                                                    </Box>
                                                    <Box>
                                                        <Box sx={{display:'flex', justifyContent:'flex-end'}}>
                                                            <UmStatusIcon stb={stb}/>
                                                            {options.viewStudentTools &&
                                                            <>
                                                                <StaffApprovalIcon booking={booking} />
                                                                <ParentApprovalIcon booking={booking}/>
                                                                <CustomMenuList 
                                                                    id={j}
                                                                    options={[
                                                                        {
                                                                            text: viewBookingButton,
                                                                            iconComponent: iconMap.Travel,
                                                                            action: () => {
                                                                                setBookingDialogueBooking(booking);
                                                                                setShowBookingDialogue(true);
                                                                            },
                                                                            branded: true
                                                                        },
                                                                        {
                                                                            text: cancelBookingButton,
                                                                            iconComponent: <Cancel/>,
                                                                            action: () => {
                                                                                setCancelBookingId(bookingId);
                                                                                setShowBookingCancelDialogue(true);
                                                                            },
                                                                            branded: true,
                                                                        },
                                                                        {
                                                                            text: changeTimeButton,
                                                                            iconComponent: <AccessTime/>,
                                                                            action: () => {
                                                                                setTimeEdit({
                                                                                    showDialogue:true,
                                                                                    wayPointId:legFromPointId,
                                                                                    pointTime:legFromPointTime
                                                                                })
                                                                            },
                                                                            branded: true,
                                                                        },
                                                                    ]}
                                                                />
                                                            </>
                                                            }
                                                        </Box>
                                                        <Box sx={{display:'flex', justifyContent:'flex-end'}}>
                                                            <Typography sx={{textAlign:'right'}} className="smallText">{bookingRefLabel} <Typography component="span" className="smallText bodyBold">{bookingId}</Typography></Typography>
                                                        </Box>
                                                        
                                                    </Box>
                                                </Box>
                                                <Divider/>
                                            </Box>
                                        );
                                    }
                                    if(staff){
                                        const {
                                            firstName='',
                                            lastName='',
                                            id:staffId
                                        } = staff;
                                        
                                        return (
                                            <Box className={`${isCancelled && 'bookingCancelled'}`} key={j}>
                                                <Box  sx={{display:'flex', marginBottom:1}}>
                                                    <Box sx={{flexGrow:'1'}}>
                                                        <Typography className="bodyBold">{firstName} {lastName}</Typography>
                                                        <Typography><Typography component="span" className="bodyBold">{luggageTaxiLabel}</Typography> {luggage}</Typography>
                                                        <Typography className="smallText">{bookedBy} {bookerName}</Typography>
                                                    </Box>
                                                    <Box>
                                                        <Box sx={{display:'flex', justifyContent:'flex-end'}}>
                                                            <UmStatusIcon stb={stb}/>
                                                            {options.viewStudentTools &&
                                                            <>
                                                                <StaffApprovalIcon booking={booking} />
                                                                <ParentApprovalIcon booking={booking}/>
                                                                <CustomMenuList 
                                                                    id={j}
                                                                    options={[
                                                                        {
                                                                            text: viewBookingButton,
                                                                            iconComponent: iconMap.Travel,
                                                                            action: () => {
                                                                                setBookingDialogueBooking(booking);
                                                                                setShowBookingDialogue(true);
                                                                            },
                                                                            branded: true
                                                                        },
                                                                        {
                                                                            text: cancelBookingButton,
                                                                            iconComponent: <Cancel/>,
                                                                            action: () => {
                                                                                setCancelBookingId(bookingId);
                                                                                setShowBookingCancelDialogue(true);
                                                                            },
                                                                            branded: true,
                                                                        },
                                                                        {
                                                                            text: changeTimeButton,
                                                                            iconComponent: <AccessTime/>,
                                                                            action: () => {
                                                                                setTimeEdit({
                                                                                    showDialogue:true,
                                                                                    wayPointId:legFromPointId,
                                                                                    pointTime:legFromPointTime
                                                                                })
                                                                            },
                                                                            branded: true,
                                                                        },
                                                                    ]}
                                                                />
                                                            </>
                                                            }
                                                        </Box>
                                                        <Box sx={{display:'flex', justifyContent:'flex-end'}}>
                                                            <Typography sx={{textAlign:'right'}} className="smallText">{bookingRefLabel} <Typography component="span" className="smallText bodyBold">{bookingId}</Typography></Typography>
                                                        </Box>
                                                        
                                                    </Box>
                                                </Box>
                                                <Divider/>
                                            </Box>
                                        );
                                    }
                                    return null;
                                })}
                           
                            </Fragment>
                            );
                        })}
                   </Box>
                   <Card variant="outlined" className="darkBox" sx={{marginLeft:'-10px', marginRight:'-10px'}}>
                        {fromPoints.map((point,index) => {
                            const {
                                pointLocation:{
                                    friendlyAddress=''
                                }
                            } = point;
                            const label = index === 0 ? taxiPointFromLabel : taxiPointViaLabel;
                            return (
                                <Box key={index}>
                                    {label} {friendlyAddress}
                                </Box>
                            );
                        })}
                        {toPoints.map((point,index) => {
                            const {
                                pointLocation:{
                                    friendlyAddress=''
                                }
                            } = point;
                            const label = index === toPoints.length-1 ? taxiPointToLabel : taxiPointViaLabel;
                            return (
                                <Box key={index}>
                                    {label} {friendlyAddress}
                                </Box>
                            );
                        })}
                   </Card>
                   {Object.values(flights).length > 0 &&
                   <Box sx={{marginTop:1, marginBottom:2}}>
                        <Typography variant="h5" sx={{textTransform:'capitalize'}}>{flightInfoLabel}</Typography>
                        {Object.values(flights).map((flight,index)=>{
                            if(!flight.flightData){
                                return null;
                            }
                            const {
                                flightNo='',
                                flightData:{
                                    manuallyEntered=false,
                                    direction='incoming',
                                    airline='',
                                    departureAirportCode='',
                                    arrivalAirportCode='',
                                    departureTerminal='',
                                    arrivalTerminal='',
                                    arrivalHoursMin={},
                                    departureHoursMin={},
                                    departureTime={},
                                    arrivalTime={}
                                }   
                            } = flight;
                            
                            if(manuallyEntered){
                                return (<Box key={index}>
                                            <strong>{flightNo} {airline}</strong><br/>
                                            {direction === 'incoming' ?
                                                <>
                                                    <Typography ><strong>{arrivingFlightTitle} {arrivalAirportCode}{arrivalTerminal ? `, ${flightLabelTerminal} ${arrivalTerminal}` : ''} at {hoursMinToTimeString(arrivalHoursMin)}</strong></Typography>
                                                </>
                                                :
                                                <>
                                                    <Typography ><strong>{departingFlightTitle} {departureAirportCode}{departureTerminal ? `, ${flightLabelTerminal} ${departureTerminal}` : ''} at {hoursMinToTimeString(departureHoursMin)}</strong></Typography>
                                                </>
                                            }
                                        </Box>);
                            }
                            
                            return (<Box key={index}>
                                        <strong>{flightNo && flightNo} {airline && airline}</strong><br/>
                                        {direction === 'incoming' ?
                                            <>
                                                <Typography className="smallText bodyBold">{arrivingFlightTitle} {arrivalAirportCode}{arrivalTerminal ? `, ${flightLabelTerminal} ${arrivalTerminal}` : ''} at {formatTime(arrivalTime.date)}</Typography>
                                                <Typography className="smallText ">{departingFlightTitle} {departureAirportCode}{departureTerminal ? `, ${flightLabelTerminal} ${departureTerminal}` : ''} at {formatTime(departureTime.date)}</Typography>
                                                
                                            </>
                                            :
                                            <>
                                                <Typography className="bodyBold">{departingFlightTitle} {departureAirportCode}{departureTerminal ? `, ${flightLabelTerminal} ${departureTerminal}` : ''} at {formatTime(departureTime.date)}</Typography><br/>
                                                <Typography >{arrivingFlightTitle} {arrivalAirportCode}{arrivalTerminal ? `, ${flightLabelTerminal} ${arrivalTerminal}` : ''} at {formatTime(arrivalTime.date)}</Typography>
                                            </>
                                        }
                                    </Box>
                            );
                            
                        })}
                    </Box>
                    }
                    {(isAdminProfile || options.showLog) && 
                        <AdminData fullData={fullData} setIsLoaded={setIsLoaded} showLog={showLog} setShowLog={setShowLog}/>
                    }
                    {(isAdminProfile || options.showLog) && 
                        <AdminFareBreakdown fareDetails={internalFareBreakdown} clientFareDetails={customerFareBreakdown}/>
                    }
                </DialogContent>
                <DialogActions>
                    <Button 
                        autoFocus 
                        onClick={()=>{
                            setShowDialogue(false)
                        }}>
                        {closeButton}
                    </Button>
                </DialogActions>
                {showBookingCancelDialogue &&
                    <CancelBookingDialogue 
                        showDialogue={showBookingCancelDialogue} 
                        setShowDialogue={(newState)=>{setShowBookingCancelDialogue(newState)}}
                        updateCall={updateAfterCancel}
                        bookingId={cancelBookingId} 
                    />
                }
                {showBookingDialogue && 
                    <BasicBookingsDialogue showDialogue={showBookingDialogue} setShowDialogue={setShowBookingDialogue} booking={bookingDialogueBooking}/>
                }
                {timeEdit.showDialogue && 
                    <TimeEdit {...timeEdit} updateCall={()=>{setIsLoaded(false)}} setShowDialogue={setShowEditDialogue}/>
                }
                {umDialogue.showDialogue &&
                    <UMToggleDialogue
                        showDialogue={umDialogue.showDialogue}
                        setShowDialogue={(show)=>{setUmDialogue({showDialogue:show,stb:0})}}
                        stb={umDialogue.stb}
                        updateCall={()=>{setIsLoaded(false)}}
                    />
                }
            </>
        );
    }

    return (
        <Dialog
            fullWidth
            open={showDialogue}
            onClose={()=>{
                setShowDialogue(false)
            }}
            className="taxiDetailDialogue"
        >
            {isLoaded ?
                <InnerDialogue/>
                :
                <LoadingBox/>
            }
        </Dialog>
    );
}




